import api from '../api';
import axios from 'axios';

export default {
    CREATE_TASK: (data) => {
        return new Promise((resolve, reject) => {
            axios
                .post(process.env.REACT_APP_BACKEND_URL + api.Task.CREATE_TASK(), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },

    MOVE_TASK_DRAG_DROP: (data) => {
        return new Promise((resolve, reject) => {
            axios
                .put(process.env.REACT_APP_BACKEND_URL + api.Task.MOVE_TASK_DRAG_DROP(), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },

    CREATE_CONTACT_TASK: (data) => {
        return new Promise((resolve, reject) => {
            axios
                .post(process.env.REACT_APP_BACKEND_URL + api.Task.CREATE_CONTACT_TASK(), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_TASK: (query) => {
        return new Promise((resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;

            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Task.GET_TASK(query))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },

    GET_ALL_TASK: (data) => {
        return new Promise((resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;

            const boardId = data?.boardId ?? data;

            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Task.GET_ALL_TASK(boardId, data?.startDate, data?.endDate))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },

    GET_TASK_CONTACT_BY_ID: (query) => {
        return new Promise((resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;

            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Task.GET_TASK_CONTACT_BY_ID(query))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },

    GET_TRAVEL_BY_TASK: (id, query) => {
        return new Promise((resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;

            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Task.GET_TRAVEL_BY_TASK(id, query))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_TASK_ID: (id) => {
        return new Promise((resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;

            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Task.GET_TASK_ID(id))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    UPDATE_TASK: (id, data) => {
        return new Promise((resolve, reject) => {
            axios
                .put(`${process.env.REACT_APP_BACKEND_URL}${api.Task.UPDATE_TASK(id)}`, data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    CREATE_TRIP: (data) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_BACKEND_URL}${api.Task.CREATE_TRIP()}`,
                    data
                );
                resolve(response);
            } catch (err) {
                reject(err);
            }
        });
    },
    UPDATE_TRIP_BY_ID: (id, data) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.put(
                    `${process.env.REACT_APP_BACKEND_URL}${api.Task.UPDATE_TRIP_BY_ID(id)}`,
                    data
                );
                resolve(response);
            } catch (err) {
                reject(err);
            }
        });
    },
    TASK_BOOKING_VIA_TRIP: (data) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_BACKEND_URL}${api.Task.TASK_BOOKING_VIA_TRIP()}`,
                    data
                );
                resolve(response);
            } catch (err) {
                reject(err);
            }
        });
    },
    DELETE_TRIP: (id) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.delete(
                    `${process.env.REACT_APP_BACKEND_URL}${api.Task.DELETE_TRIP(id)}`
                );
                resolve(response);
            } catch (err) {
                reject(err);
            }
        });
    },
    DELETE_TASK_TRIP: (id) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.delete(
                    `${process.env.REACT_APP_BACKEND_URL}${api.Task.DELETE_TASK_TRIP(id)}`
                );
                resolve(response);
            } catch (err) {
                reject(err);
            }
        });
    },
    UPDATE_CANCEL_BOOKING_BY_ID: (id, data, type) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.put(
                    `${process.env.REACT_APP_BACKEND_URL}${api.Task.UPDATE_CANCEL_BOOKING_BY_ID(id, type)}`,
                    data
                );
                resolve(response);
            } catch (err) {
                reject(err);
            }
        });
    },

    // reply on one checklist task of a ticket: data = { ruleId, label, text }
    CHECKLIST_REPLY: (id, data) => {
        return new Promise((resolve, reject) => {
            axios
                .post(`${process.env.REACT_APP_BACKEND_URL}${api.Task.CHECKLIST_REPLY(id)}`, data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    UPDATE_TASK_GMAIL_WHATSAAP: (id, data) => {
        return new Promise((resolve, reject) => {
            axios
                .put(`${process.env.REACT_APP_BACKEND_URL}${api.Task.UPDATE_TASK_GMAIL_WHATSAAP(id)}`, data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    DELETE_TASK: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .delete(process.env.REACT_APP_BACKEND_URL + api.Task.DELETE_TASK(id))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    UPDATE_CHILD_TASK: (id, data) => {
        return new Promise((resolve, reject) => {
            axios
                .put(`${process.env.REACT_APP_BACKEND_URL}` + api.Task.UPDATE_CHILD_TASK(id), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },

    GET_TASK_BY_ID: (query, extraHeaders) => {
        return new Promise((resolve, reject) => {
            axios.get(process.env.REACT_APP_BACKEND_URL + api.Task.GET_TASK_BY_ID(query), {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    ...extraHeaders,
                },
            })
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },

    ARCHIVE_TASK: ({ taskId, boardId }) => {
        return new Promise((resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;

            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Task.ARCHIVE_TASK(taskId, boardId))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    TASK_LINK_DATA: (data) => {
        return new Promise((resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
            axios.post(process.env.REACT_APP_BACKEND_URL + api.Task.TASK_LINK_DATA(), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_TASK_LINK_DATA: (id) => {
        return new Promise((resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
            axios.get(process.env.REACT_APP_BACKEND_URL + api.Task.GET_TASK_LINK_DATA(id))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    DELETE_TASK_ATTACHEMENT: (id, attachId) => {
        return new Promise((resolve, reject) => {
            axios
                .delete(process.env.REACT_APP_BACKEND_URL + api.Task.DELETE_TASK_ATTACHEMENT(id, attachId))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },


    GET_ALL_DEPENDENCIES: () => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Task.GET_ALL_DEPENDENCIES())
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_TASK_DEPENDENCIES: (taskId) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Task.GET_TASK_DEPENDENCIES(taskId))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    CREATE_DEPENDENCY: (data) => {
        return new Promise((resolve, reject) => {
            axios
                .post(process.env.REACT_APP_BACKEND_URL + api.Task.CREATE_DEPENDENCY(), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    DELETE_DEPENDENCY: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .delete(process.env.REACT_APP_BACKEND_URL + api.Task.DELETE_DEPENDENCY(id))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_CHAT_DETAILS: (id, query) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Task.GET_CHAT_DETAILS(id, query))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_TRIP_BY_TASKID: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Task.GET_TRIP_BY_TASKID(id))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_TRIP_BY_ID: (id, query) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Task.GET_TRIP_BY_ID(id, query))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
};
